<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="角色编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.roleCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="角色名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.roleName" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="角色管理">
                <el-button v-authority="'BACK_MENU8_M1_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">
                    新增
                </el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="roleId" label="序号"></el-table-column> -->
                <el-table-column prop="roleCode" label="角色编号" />
                <el-table-column prop="roleName" label="角色名称" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="updateTime" label="修改时间" />
                <el-table-column label="权限操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="roleOpen(scope.row)" v-authority="'BACK_MENU8_M1_B4'">
                            权限操作
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU8_M1_B2'" size="mini" type="primary" @click="(add_or_edit = false),(editBoxShow = true),(mainObj = JSON.parse(JSON.stringify(scope.row)))" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU8_M1_B3'" type="danger" @click="deleteRow(scope.row.roleId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 权限操作 -->
        <el-dialog title="权限" :close-on-click-modal="false" :visible.sync="roleopera" style="" width="800px">
            <div class="treeBox">
                <div class="menuBox">
                    <el-tree :data="allRoles" :check-strictly="false" ref="roleTree" @node-click="nodeClick" node-key="authId" show-checkbox :props="treeProps" :default-expanded-keys="[1]">
                    </el-tree>
                </div>
                <div class="btnBox">
                    <div v-for="btn in btnRoles" :key="btn.authId" :class="{ own: ifOwn(btn.authId) }" @click="setRole(btn)">
                        {{ btn.authName }}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="cancel">取 消</el-button>
                <el-button size="small" type="primary" @click="roleUpdate">修 改</el-button>
            </span>
        </el-dialog>

        <!-- 新增编辑 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-form-item label="角色编号" prop="roleCode">
                        <el-input v-model="mainObj.roleCode"> </el-input>
                    </el-form-item>
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input v-model="mainObj.roleName"> </el-input>
                    </el-form-item>
                    <el-form-item label="角色等级" prop="roleLevel">
                        <el-input v-model="mainObj.roleLevel"> </el-input>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="mainObj = {},editBoxShow = false">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    roleCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    roleName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    roleLevel: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                allRoles: [], //所有权限
                btnRoles: [], //按钮权限
                roleId: "",
                userRoles: [], //用户权限
                treeProps: {
                    children: "sonList",
                    label: "authName",
                },
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                roleopera: false, //角色操作框
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    roleCode: "",
                    roleName: "",
                },
                treeProps: {
                    children: "sonList",
                    label: "authName",
                },
                mainData: [{
                    roleId: null,
                    roleCode: "",
                    roleName: "",
                    roleLevel: "",
                    updateTime: "",
                    createTime: "",
                }, ],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "api/role/getRoleAll",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            roleCode: this.pagination.roleCode,
                            roleName: this.pagination.roleName,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                            // console.log(this.mainData);
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //按钮点击
            setRole(btn) {
                // console.log("btn", btn);
                for (let i in this.userRoles) {
                    if (this.userRoles[i].authId == btn.authId) {
                        this.userRoles.splice(i, 1);
                        return;
                    }
                }
                this.userRoles.push(btn);
            },
            //权限框打开
            roleOpen(obj) {
                // 权限框打开
                this.roleopera = true;
                this.roleId = obj.roleId;
                this.btnRoles = [];
                //查询所有权限
                this.$http
                    .request({
                        url: "/api/authority/tree",
                        method: "GET",
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.allRoles = resp.data || [];
                            this.setTreeByKeys();
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "所有权限查询失败",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                this.getRoleAuth(obj.roleId);
            },
            //查询角色权限
            getRoleAuth(roleId) {
                // return
                this.$http
                    .request({
                        url: "/api/authority/getRoleAuth",
                        method: "GET",
                        params: {
                            roleId: roleId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.userRoles = resp.data || [];
                            this.setTreeByKeys();
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "用户权限查询失败",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            },
            setTreeByKeys() {
                if (this.userRoles.length) {
                    let list = [];
                    let setCheckedKeysList = [];
                    let parent = [];
                    let num = 0;
                    for (let i in this.userRoles) {
                        if (this.userRoles[i].parentId != 0 && this.userRoles[i].parentId != 1) {
                            setCheckedKeysList.push(this.userRoles[i].authId);
                            list.push(this.userRoles[i])
                        } else {
                            parent.push(this.userRoles[i].authId);
                        }
                    }

                    let parentId = [];
                    for (let i in parent) {
                        for (let j in list) {
                            num = num + 1;
                            if (parent[i] == list[j].parentId) {
                                num = 0;
                                break
                            }
                        }
                        if (num == list.length) {
                            //parentId.push(parent[i])
                        }
                    }

                    for (let i in parentId) {
                        setCheckedKeysList.push(parentId[i])
                    }

                    this.$refs.roleTree.setCheckedKeys(setCheckedKeysList);

                }
            },

            //节点点击 查询当前页面按钮
            nodeClick(data) {
                if (data.authType == "menu") {
                    //查询按钮
                    this.$http
                        .request({
                            url: "/api/authority/buttonALL",
                            method: "GET",
                            showLoading: true,
                            params: {
                                parentId: data.authId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                let btnRoles = [];
                                for (let i in resp.data) {
                                    if (resp.data[i].authType == "button") {
                                        btnRoles.push(resp.data[i]);
                                    }
                                }
                                this.btnRoles = btnRoles;
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "权限查询失败",
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //是否拥有此权限
            ifOwn(id) {
                for (let i in this.userRoles) {
                    if (this.userRoles[i].authId == id) return true;
                }
                return false;
            },
            //权限修改
            roleUpdate() {
                //获取tree已选权限
                let all = this.$refs.roleTree.getCheckedKeys();
                let aaa = this.$refs.roleTree.getHalfCheckedKeys();
                all = all.concat(aaa);
                let userRoles = [];
                for (let i in this.userRoles) {
                    if (this.userRoles[i].authType == "button")
                        userRoles.push(this.userRoles[i].authId);
                }
                all = JSON.stringify(all.concat(userRoles));
                // console.log("all", all)
                this.$http
                    .request({
                        url: "/api/authority/insert",
                        method: "POST",
                        showLoading: true,
                        params: {
                            roleId: this.roleId,
                            authIds: all.substring(1, all.length - 1),
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.roleopera = false;
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "userRole：该角色修改权限成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "修改失败",
                            });
                            this.logRemarks = "userRole：该角色修改权限失败";
                        }
                        this.logContent = "roleId: " + this.roleId + "，authIds:" + all;
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败" + error,
                        });
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(
                        JSON.stringify({
                            roleId: null,
                            roleCode: "",
                            roleName: "",
                            roleLevel: "",
                            createTime: "",
                            updateTime: "",
                        })
                    );
                } else {
                    this.getAuxiMaterialData();
                    // setTimeout(() => {
                    // this.$refs.cascadeSearch.reSetData(this.mainObj.fcCode, this.mainObj.shopCode, this.mainObj.lineCode)
                    // }, 200)
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/role/insertRole",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "role：角色新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "role：角色新增失败";
                            }
                            this.logContent = "roleCode：" + this.mainObj.roleCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/role/updateRole",
                            method: "PUT",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "role：角色修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "role：角色修改失败";
                            }
                            this.logContent = "roleCode：" + this.mainObj.roleCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(roleId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/role/deleteRole",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    roleId: roleId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "role：角色删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "role：角色删除成功";
                                }
                                this.logContent = "roleId：" + roleId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    roleCode: "",
                    roleName: "",
                };
                this.getAuxiMaterialData();
            },

            cancel() {
                this.allRoles = [];
                this.$nextTick(function() {
                    this.$refs.roleTree.setCheckedKeys([]);
                });
                this.roleopera = false;
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "角色管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>